import { render, staticRenderFns } from "./stock-history-order.vue?vue&type=template&id=1d2d7380"
import script from "./stock-history-order.vue?vue&type=script&lang=js"
export * from "./stock-history-order.vue?vue&type=script&lang=js"
import style0 from "./stock-history-order.vue?vue&type=style&index=0&id=1d2d7380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports